<template>
  <div>
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-plus"
      @click="openEditGreyListEntryDialog(true)"
      >新增灰名单项</el-button
    >

    <el-form
      ref="form"
      :model="form"
      label-width="120px"
      size="mini"
      style="margin-top: 30px"
    >
      <el-form-item label="查询方式：">
        <el-radio-group v-model="form.queryType">
          <el-radio :label="1">按渠道</el-radio>
          <el-radio :label="2">按UID</el-radio>
        </el-radio-group>
      </el-form-item>
      <div v-if="form.queryType == 1">
        <el-form-item label="渠道：">
          <channel-selector
            placeholder="请选择渠道"
            @ready="onChannelSelectorReady"
            @change="onChannelSelectorChange"
            style="display: inline-block"
            ref="channelSelector"
          >
          </channel-selector>
        </el-form-item>
        <el-form-item label="原因：">
          <el-select v-model="form.eventScene">
            <el-option
              v-for="item in eventSceneOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <el-form-item label="UID：" v-if="form.queryType == 2">
        <el-input v-model="form.uid" style="width: 172px"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="onClickQueryBtn()"
          >查询</el-button
        >
      </el-form-item>
    </el-form>

    <el-table
      :data="greyListTableData"
      v-el-table-infinite-scroll="loadMore"
      :infinite-scroll-disabled="greyListTableData.length == 0"
      border
      size="small"
      height="500px"
      style="width: 940px; margin-left: 120px"
    >
      <el-table-column prop="when" label="时间" align="center" width="160">
      </el-table-column>
      <el-table-column prop="uid" label="UID" align="center" width="100">
      </el-table-column>
      <el-table-column
        prop="moduleDesc"
        label="禁用模块"
        align="center"
        width="120"
      >
      </el-table-column>
      <el-table-column
        prop="eventSceneDesc"
        label="原因"
        align="center"
        width="160"
      >
      </el-table-column>
      <el-table-column prop="context" label="备注" align="center" width="250">
      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template scope="scope">
          <el-button
            type="danger"
            round
            size="mini"
            @click="onClickDeleteGreyListBtn(scope.row.uid, scope.row.module)"
            >删除</el-button
          >
          <el-button
            round
            size="mini"
            @click="onClickViewLogsBtn(scope.row.uid)"
            >日志</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- “添加/修改灰名单项”对话框 -->
    <EditGreyListEntryDialog
      v-if="shouldEditGreyListEntryDialogVisible"
      @close="onEditGreyListEntryDialogClosed()"
      :value="valueForEditGreyListEntryDialog"
    ></EditGreyListEntryDialog>
  </div>
</template>

<script>
const axios = require("axios");
const moment = require("moment");
const util = require("../../util");

import EditGreyListEntryDialog from "./EditGreyListEntryDialog";
import ChannelSelector from "@/components/ChannelSelector";

export default {
  data() {
    return {
      shouldEditGreyListEntryDialogVisible: false, // “添加/修改灰名单项”对话框是否应该显示出来
      valueForEditGreyListEntryDialog: null, // 要传递给“添加/修改灰名单项”对话框的数据
      greyListTableData: [], // 灰名单列表里展示的数据
      availableModules: {
        // 所有模块的定义
        1: "活跃排行榜",
        2: "排行榜",
        4: "巅峰之塔",
      },
      eventSceneOptions: [
        {
          value: 0,
          label: "<全部>",
        },
        {
          value: 6,
          label: "最大关卡记录校验",
        },
        {
          value: 7,
          label: "巅峰之塔校验",
        },
        {
          value: 8,
          label: "总战力校验",
        },
        {
          value: 9,
          label: "管理员手动",
        },
        {
          value: 10,
          label: "客户端日志上报",
        },
      ],
      form: {
        queryType: 1, // 查询方式（1-根据渠道查询 2-根据uid查询）
        uid: "",
        channelId: "",
        eventScene: 0,
      },
    };
  },

  components: {
    EditGreyListEntryDialog,
    ChannelSelector,
  },

  methods: {
    async onChannelSelectorReady() {
      this.$refs.channelSelector.channelId = this.form.channelId;
    },

    async onChannelSelectorChange(newChannelId, oldChannelId) {
      this.form.channelId = newChannelId;
    },

    loadMore() {
      this.loadGreyList(this.greyListTableData.length, 20);
    },

    /**
     * 点击了灰名单项的删除按钮
     * @param {*} uid
     * @param {*} module
     */
    onClickDeleteGreyListBtn(uid, module) {
      this.$confirm("此操作将删除该灰名单项，是否继续?", "提示", {
        confirmButtonText: "继续",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.deleteGreyListEntry(uid, module);

          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消删除",
          });
        });
    },

    /**
     * 点击了查看日志按钮
     */
    onClickViewLogsBtn(uid) {
      // 挑战到查询日志页面
      this.$router.push({ path: "/console/misc/clientlog", query: { uid: uid } });
    },

    /**
     * 查询灰名单
     */
    async loadGreyList(skip, limit) {
      switch (this.form.queryType) {
        case 1: {
          // 根据渠道查

          let channelId = parseInt(this.form.channelId);
          if (isNaN(channelId) || channelId <= 0) {
            this.$message({
              message: "请选择渠道",
              type: "error",
            });
            return;
          }

          // 如果是要从头开始拉（而不是继续拉剩下的），那就先清空原有记录
          if (skip == 0) {
            this.greyListTableData = [];
          }

          let resData = (
            await axios.post(
              `${util.getBackendApiBase()}/v1/getGreyList`,
              {
                channelId: channelId,
                eventScene: this.form.eventScene,
                skip: skip,
                limit: limit,
              },
              {
                headers: {
                  token: util.getLoginUserToken(),
                },
              }
            )
          ).data;
          if (resData.code > 0) {
            this.$message({
              message: resData.message,
              type: "error",
            });
            return;
          }

          let listInResp = resData.data.greyLists || [];

          let list = [];
          for (let e of listInResp) {
            list.push({
              uid: e.uid,
              module: e.module,
              moduleDesc: this.availableModules[e.module],
              eventSceneDesc: e.remark,
              context: e.context,
              when: moment(parseInt(e.createAt)).format("yyyy-MM-DD HH:mm:ss"),
            });
          }

          this.greyListTableData = this.greyListTableData.concat(list);

          break;
        }
        case 2: {
          // 根据uid查

          let uid = parseInt(this.form.uid);
          if (isNaN(uid) || uid <= 0) {
            this.$message({
              message: "请填入正确的UID",
              type: "error",
            });
            return;
          }

          let resData = (
            await axios.post(
              `${util.getBackendApiBase()}/v1/findOneGreyList`,
              {
                uid: uid,
              },
              {
                headers: {
                  token: util.getLoginUserToken(),
                },
              }
            )
          ).data;
          if (resData.code > 0) {
            this.$message({
              message: resData.message,
              type: "error",
            });
            return;
          }

          let listInResp = resData.data.greyLists || [];

          let list = [];
          for (let e of listInResp) {
            list.push({
              uid: e.uid,
              module: e.module,
              moduleDesc: this.availableModules[e.module],
              eventSceneDesc: e.remark,
              context: e.context,
              when: moment(parseInt(e.createAt)).format("yyyy-MM-DD HH:mm:ss"),
            });
          }

          this.greyListTableData = list;

          break;
        }
      }
    },

    /**
     * 删除一个灰名单项
     */
    async deleteGreyListEntry(uid, module) {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/deleteGreyList`,
          {
            uidList: [uid],
            module: module,
          },
          {
            headers: {
              token: util.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      // 重新拉灰名单
      return this.loadGreyList(0, 20);
    },

    /**
     * 打开“添加/修改灰名单项”对话框
     */
    async openEditGreyListEntryDialog(isCreate, oldData) {
      this.shouldEditGreyListEntryDialogVisible = true;
      this.valueForEditGreyListEntryDialog = {
        isCreate: isCreate,
        oldData: oldData,
      };
    },

    /**
     * “添加/修改灰名单项”对话框关闭了
     */
    async onEditGreyListEntryDialogClosed() {
      this.shouldEditGreyListEntryDialogVisible = false;
    },

    /**
     * 点击了查询按钮
     */
    async onClickQueryBtn() {
      await this.loadGreyList(0, 20);
    },
  },
};
</script>